<template>
  <!-- 页面主内容占位 -->
  <router-view />

  <!-- 悬浮工具栏 HTML 结构（仅前台显示） -->
  <div v-if="!isAdminRoute" class="floating-tools">
    <!-- 电话工具 -->
    <div class="tool-item">
      <!-- 确保引入了 Phone 图标 -->
      <el-icon><Phone /></el-icon>
      <div class="tool-tip">{{ phone }}</div>
    </div>

    <!-- 微信工具 -->
    <div class="tool-item">
      <!-- 确保引入了 ChatDotRound 图标 -->
      <el-icon><ChatDotRound /></el-icon>
      <div class="tool-tip">
        微信咨询<br />
        <img :src="qrcodeUrl" style="width: 100px" alt="微信二维码" />
      </div>
    </div>
  </div>
</template>

<script setup>
// 引入 Element Plus 的图标
import { Phone, ChatDotRound } from "@element-plus/icons-vue";
import { computed } from "vue";
import { useSettingStore } from "@/stores/setting";
import { useRoute } from "vue-router";

const route = useRoute();
const settingStore = useSettingStore();

const isAdminRoute = computed(() => {
  return route.path.startsWith("/admin");
});

const phone = computed(() => {
  const setting = settingStore.setting;
  return Array.isArray(setting?.phone)
    ? setting.phone[0]
    : setting?.phone || "400-123-4567";
});

const qrcodeUrl = computed(() => {
  const setting = settingStore.setting;
  return setting?.wechatQrcode || "@/assets/img/qrcode.png";
});
</script>

<style lang="scss" scoped>
/* 悬浮工具栏样式 */
.floating-tools {
  position: fixed;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  z-index: 999;
  display: flex;
  flex-direction: column; /* 确保垂直排列 */
}

.tool-item {
  width: 50px;
  height: 50px;
  background: #182848;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  margin-bottom: 2px;
  cursor: pointer;
  position: relative;
  transition: background 0.3s; /* 增加过渡效果更平滑 */
}

.tool-item:hover {
  background: #3b8cff;
}

.tool-tip {
  position: absolute;
  right: 60px;
  top: 0; /* 对齐顶部 */
  background: #fff;
  color: #333;
  padding: 10px 15px;
  font-size: 14px;
  border: 1px solid #ddd;
  display: none;
  white-space: nowrap;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  border-radius: 4px; /* 增加圆角更美观 */
  text-align: center;
}

/* 微信二维码图片稍微调整一下显示 */
.tool-tip img {
  display: block;
  margin: 5px auto 0;
}

.tool-item:hover .tool-tip {
  display: block;
}
</style>
